module.exports = __webpack_public_path__ + "brand-icons.ac80d259e54bf42f0fc9.svg";


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/fonts/brand-icons/brand-icons.svg?v=0.3.2
// module id = ../../../../../src/fonts/brand-icons/brand-icons.svg?v=0.3.2
// module chunks = styles